// extracted by mini-css-extract-plugin
export var cardWrapper = "_7d-0";